import { PageShell } from '@vanilla/ui'
import { Header } from './Header'
import { Footer } from './Footer'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  return <PageShell header={<Header />} footer={<Footer />}>{children}</PageShell>
}
